import React, { useState } from 'react';
import Api from '../common/Api';
import qs from 'qs';
import { useDispatch } from 'react-redux';
//import { setFirstName, setAccessToken, setuserLoggedIn } from '../store/userActions';
import * as UA from '../store/userActions';

export default function Signin(props) {

    const [input, setInput] = useState({
        userName: "",
        password: "",
    });

    const [warn, setWarn] = useState("");

    const dispatch = useDispatch();


    function onChange(e) {
        setInput({
            ...input,
            [e.currentTarget.name]: e.currentTarget.value
        });
    }

    function signIn() {

        const data = qs.stringify({
            grant_type: "password",
            userName: input.userName !== "" ? input.userName : "fishlet@yahoo.com",
            password: input.password !== "" ? input.password : "he#kG8gjGh"
        });

        //{ headers: headers }
        Api.post("/TOKEN", data )
            .then((resp) => {

                // FIXME... put here for now... gonna see if we use cookies and not have to stash manually. 
                dispatch(UA.setAccessToken(resp.data.access_token));
                dispatch(UA.setuserLoggedIn(true));

                // Now that we have auth info... lets get some more information about the user. 
                var hdrs = { 'Content-Type': 'application/x-www-form-urlencoded' };
                hdrs.Authorization = 'Bearer ' + resp.data.access_token;

                Api.get("/api/Account/UserInfo", { headers: hdrs }).then((resp) => {

                    dispatch(UA.setFirstName(resp.data.FirstName));

                    // Go Home
                    props.history.push("/");

                }).catch(err => {
                    alert("get info failed");
                });

            })
            .catch(() => { setWarn("Email or Password is incorrect."); });
            
    }

    return (
        <div>
            <div className="container">

                <div className='card mt-2 p-3'>

                    <h2>Sign In</h2>
                    <p>
                        Some site features require an acount. Please login below or <a href="#register">create an account.</a>
                    </p>
                    <form>
                        <div className="form-group">
                            <label htmlFor="userName">Email</label>
                            <input className="form-control" type="email" name="userName" value={input.userName} onChange={onChange} placeholder="User Name" />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input className="form-control password" type="password" name="password" onChange={onChange} placeholder="Password" />
                        </div>

                        {warn === "" ? null :
                            <p className="red" >{warn} </p>
                        }

                    </form>
                    <button className="btn btn-primary" onClick={signIn} >Sign In</button>

                </div>

            </div>

        </div>
    );
}



